import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ReactComponent } from '@sketch/icons/cross-16-svg';
import { Wrapper, ChildrenWrapper, CloseWrapper } from './Toast.styles.js';

const testIds = {
    default: 'toast-default',
    negative: 'toast-negative',
    positive: 'toast-positive',
};
const Toast = (_a) => {
    var { children, id, variant, onClose } = _a, props = __rest(_a, ["children", "id", "variant", "onClose"]);
    return (jsxs(Wrapper, Object.assign({ id: id, "data-testid": testIds[variant], variant: variant, role: "alert" }, props, { children: [jsx(ChildrenWrapper, { children: children }), onClose && (jsx(CloseWrapper, Object.assign({ "data-testid": "toast-close", onClick: onClose }, { children: jsx(ReactComponent, { width: 16, height: 16 }) })))] })));
};

export { Toast };
